import { useCallback, useState } from 'react'
import Cookies from 'js-cookie'
import { useStores } from './useStores'

export default function useLayoutState(
  key: 'plaza-layout' | 'homepage-layout',
  initialValue: string
): [string, (n: string) => void] {
  const { store } = useStores()
  const [state, setState] = useState(store?.layout?.[key] || initialValue)
  const setStateWrapper = useCallback((v: string) => {
    setState(v)
    Cookies.set(key, v)
  }, [])

  return [state, setStateWrapper]
}
